export default __webpack_public_path__ + "static/media/PrincipeClosed.11321b3a.jpg";